import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  id: "login-page",
  class: "relative mx-auto h-full w-full max-w-screen-md p-8 md:p-0"
}
const _hoisted_2 = { class: "pt-32 mx-auto max-w-sm" }
const _hoisted_3 = {
  key: 1,
  class: "elevation-6 px-4 pt-7 pb-4 rounded-md text-center border-green-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.successState)
        ? (_openBlock(), _createBlock(_component_v_form, {
            key: 0,
            ref: "form",
            class: "elevation-6 p-4 rounded-md white",
            "lazy-validation": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                autocomplete: "false",
                class: "mb-2",
                label: "E-mail",
                required: "",
                variant: "outlined",
                rules: _ctx.emailRules
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_btn, {
                disabled: !_ctx.email,
                color: "primary",
                onClick: _ctx.sendResetLinkToEmail
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Send reset link ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          }, 512))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("h1", { class: "text-xl text-green-600" }, "Password reset link sent to your email!", -1),
            _createElementVNode("p", { class: "text-sm" }, "Please check your inbox", -1)
          ]))]))
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.errorState,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.errorState) = $event)),
      color: "error",
      timeout: "3000"
    }, {
      action: _withCtx(({ attrs }) => [
        _createVNode(_component_v_btn, _mergeProps({
          color: "white",
          text: ""
        }, attrs, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errorState = false))
        }), {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.errorStateText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}